import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  SxProps,
  Theme,
} from "@mui/material";
import React from "react";

export interface IDialogOption {
  title: string;
  handleOption: () => void;
  closeAfterClick?: boolean;
}

interface MissingMasspointsComponentProps {
  title: string;
  onClose: () => void;
  isOpen: boolean;
  options: Array<IDialogOption>;
  children: React.ReactNode;
  container?: HTMLElement;
  dialogSx?: SxProps<Theme>;
}

export const DialogComponent: React.FC<MissingMasspointsComponentProps> = ({
  title,
  onClose,
  isOpen,
  options,
  children,
  container,
  dialogSx,
}) => {
  const handleClose = () => {
    onClose();
  };

  const handleOptionAndClose = (option: IDialogOption) => {
    option.handleOption();
    if (option.closeAfterClick !== false) {
      handleClose();
    }
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        container={container}
        disableScrollLock={!!container}
        maxWidth={false}
        sx={dialogSx}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>

        <DialogContent>
          <DialogContentText component="div">
            <div id="alert-dialog-description">{children}</div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {options.map((option, index) => (
            <Button
              variant="outlined"
              key={index}
              onClick={() => handleOptionAndClose(option)}
            >
              {option.title}
            </Button>
          ))}
        </DialogActions>
      </Dialog>
    </div>
  );
};
